<div class="w-full max-w-6xl mx-auto p-6">
  @if (initialLoad()) {
    <p-card styleClass="sale-form-card">
      <ng-template pTemplate="header">
        <div class="px-4 py-3 border-b border-slate-200 bg-slate-50/50">
          <div class="flex items-center gap-3">
            <p-button
              icon="pi pi-arrow-left"
              [rounded]="true"
              [text]="true"
              severity="secondary"
              type="button"
              (onClick)="cancel()"
              pTooltip="Volver"
              tooltipPosition="bottom"
            />
            <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2 min-w-0">
              <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
                <i class="pi pi-cog"></i>
              </span>
              <span class="truncate">Cargando...</span>
            </h2>
          </div>
        </div>
      </ng-template>
      <div class="flex items-center justify-center py-12">
        <i class="pi pi-spin pi-spinner text-4xl text-slate-400"></i>
      </div>
    </p-card>
  } @else {
    <form [formGroup]="configForm" (ngSubmit)="onSubmit()">
      <p-card styleClass="sale-form-card">
        <ng-template pTemplate="header">
          <div class="px-4 py-3 border-b border-slate-200 bg-slate-50/50">
            <div class="flex items-center gap-3">
              <p-button
                icon="pi pi-arrow-left"
                [rounded]="true"
                [text]="true"
                severity="secondary"
                type="button"
                (onClick)="cancel()"
                pTooltip="Volver"
                tooltipPosition="bottom"
              />
              <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2 min-w-0">
                <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
                  <i class="pi pi-cog"></i>
                </span>
                <span class="truncate">Configuración</span>
              </h2>
            </div>
          </div>
        </ng-template>

        <div formGroupName="companyConfig">
          <div formGroupName="companyInvoiceConfig">
            <p-tabs [value]="activeTab()" (valueChange)="activeTab.set($event)" class="">
              <p-tablist>
                @for (tab of tabs; track tab.value) {
                  <p-tab [value]="tab.value" class="flex items-center gap-2! text-inherit">
                    @if (tab.matIcon) {
                      <mat-icon class="!text-xl !w-5 !h-5 !leading-5">{{ tab.matIcon }}</mat-icon>
                    } @else {
                      <i [class]="tab.icon"></i>
                    }
                    <span>{{ tab.label }}</span>
                  </p-tab>
                }
              </p-tablist>
              <p-tabpanels>
                <p-tabpanel value="facturacion">
                  <div class="mt-4 mb-4">
                    <h3 class="text-lg font-semibold text-slate-900">Facturación</h3>
                    <p class="text-sm text-slate-500">Opciones de emisión de facturas (CFDI) para la empresa.</p>
                  </div>
                  <div class="flex flex-col gap-4 mt-4 max-w-2xl">
                    <div class="flex items-center justify-between gap-4 rounded-lg border border-slate-200 bg-slate-50/80 px-4 py-3">
                      <div class="min-w-0">
                        <label for="enableInvoice" class="block text-sm font-medium text-slate-900">Habilitar facturación</label>
                        <p class="text-xs text-slate-500 mt-0.5">Permite generar facturas desde ventas y cobros.</p>
                      </div>
                      <p-toggleswitch formControlName="enableInvoice" inputId="enableInvoice" />
                    </div>
                    <div class="flex items-center justify-between gap-4 rounded-lg border border-slate-200 bg-slate-50/80 px-4 py-3">
                      <div class="min-w-0">
                        <label for="enableAutoInvoice" class="block text-sm font-medium text-slate-900">Facturación automática</label>
                        <p class="text-xs text-slate-500 mt-0.5">Emite la factura de forma automática al confirmar el cobro.</p>
                      </div>
                      <p-toggleswitch formControlName="enableAutoInvoice" inputId="enableAutoInvoice" />
                    </div>
                  </div>
                </p-tabpanel>

                <p-tabpanel value="ventas">
                  <div formGroupName="companySaleConfig">
                    <div class="mt-4 pt-2">
                      <div class="flex items-start justify-between gap-4 mb-4">
                        <div>
                          <h3 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
                            <i class="pi pi-sliders-h"></i>
                            Campos dinámicos
                          </h3>
                          <p class="text-sm text-slate-500">Campos adicionales al crear o editar una venta.</p>
                        </div>
                        <p-button label="Agregar campo" icon="pi pi-plus" size="small" type="button" (onClick)="addDynamicField('sale')" />
                      </div>

                    <div formArrayName="dynamicFields" class="flex flex-col gap-4">
                      @if (saleDynamicFieldsArray.length === 0) {
                        <div class="rounded-lg border border-dashed border-slate-200 bg-slate-50 px-4 py-8 text-center text-sm text-slate-500">
                          No hay campos dinámicos configurados.
                        </div>
                      }
                      @for (fieldCtrl of saleDynamicFieldsArray.controls; track $index; let i = $index) {
                        <div [formGroupName]="i" class="rounded-lg border border-slate-200 bg-slate-50/60 p-4">
                          <div class="flex items-center justify-between gap-3 mb-4">
                            <span class="text-sm font-medium text-slate-800">Campo {{ i + 1 }}</span>
                            <p-button
                              icon="pi pi-trash"
                              [rounded]="true"
                              [text]="true"
                              severity="danger"
                              type="button"
                              (onClick)="removeDynamicField('sale', i)"
                              pTooltip="Eliminar campo"
                              tooltipPosition="left"
                            />
                          </div>
                          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div class="flex flex-col gap-1">
                              <p-floatlabel variant="on">
                                <input
                                  pInputText
                                  [id]="'sale-fieldLabel-' + i"
                                  formControlName="label"
                                  [maxlength]="200"
                                  fluid
                                  autocomplete="off"
                                  (blur)="onLabelBlur('sale', i)"
                                  [invalid]="(fieldCtrl.get('label')?.invalid ?? false) && (fieldCtrl.get('label')?.touched ?? false)"
                                />
                                <label [for]="'sale-fieldLabel-' + i">Etiqueta <span class="text-red-500">*</span></label>
                              </p-floatlabel>
                              <p class="text-xs text-slate-500">Nombre con el que se mostrará en el formulario de ventas.</p>
                              @if (fieldCtrl.get('label')?.hasError('required') && fieldCtrl.get('label')?.touched) {
                                <small class="text-red-600">La etiqueta es requerida</small>
                              } @else if (fieldCtrl.get('label')?.hasError('specialChars') && fieldCtrl.get('label')?.touched) {
                                <small class="text-red-600">Solo letras, números y espacios (se permiten acentos)</small>
                              }
                            </div>
                            <div class="flex flex-col gap-1">
                              <p-floatlabel variant="on">
                                <input
                                  pInputText
                                  [id]="'sale-fieldKey-' + i"
                                  formControlName="fieldKey"
                                  [maxlength]="100"
                                  fluid
                                  autocomplete="off"
                                  [invalid]="(fieldCtrl.get('fieldKey')?.invalid ?? false) && (fieldCtrl.get('fieldKey')?.touched ?? false)"
                                />
                                <label [for]="'sale-fieldKey-' + i">Clave <span class="text-red-500">*</span></label>
                              </p-floatlabel>
                              <p class="text-xs text-slate-500">
                                @if (isFieldKeyLocked('sale', i)) {
                                  La clave no se puede modificar una vez guardada.
                                } @else {
                                  Nombre interno del campo. No se mostrará al usuario.
                                }
                              </p>
                            </div>
                            <div class="flex flex-col gap-1">
                              <p-floatlabel class="w-full" variant="on">
                                <p-select
                                  formControlName="type"
                                  [inputId]="'sale-fieldType-' + i"
                                  [options]="dynamicFieldTypeOptions"
                                  optionLabel="label"
                                  optionValue="value"
                                  class="w-full"
                                  (onChange)="onDynamicFieldTypeChange()"
                                />
                                <label [for]="'sale-fieldType-' + i">Tipo</label>
                              </p-floatlabel>
                            </div>
                            @if (isSelectFieldType('sale', i)) {
                              <div class="flex flex-col gap-1 md:col-span-2">
                                <p-floatlabel variant="on">
                                  <input
                                    pInputText
                                    [id]="'sale-fieldOptions-' + i"
                                    formControlName="optionsText"
                                    [maxlength]="1000"
                                    fluid
                                    autocomplete="off"
                                  />
                                  <label [for]="'sale-fieldOptions-' + i">Opciones (separadas por coma)</label>
                                </p-floatlabel>
                                <p class="text-xs text-slate-500">Ej: Opción A, Opción B, Opción C</p>
                              </div>
                            }
                            <div class="flex flex-col gap-1 md:col-span-2">
                              <p-floatlabel variant="on">
                                <input
                                  pInputText
                                  [id]="'sale-fieldRegex-' + i"
                                  formControlName="validationRegex"
                                  [maxlength]="500"
                                  fluid
                                  autocomplete="off"
                                />
                                <label [for]="'sale-fieldRegex-' + i">Regex de validación (opcional)</label>
                              </p-floatlabel>
                            </div>
                            <div class="flex flex-wrap items-center gap-4 md:col-span-2">
                              <div class="flex items-center gap-3 min-h-[2.75rem] px-3 border border-slate-300 rounded-md bg-white">
                                <p-checkbox formControlName="required" [inputId]="'sale-fieldRequired-' + i" [binary]="true" />
                                <label [for]="'sale-fieldRequired-' + i" class="cursor-pointer select-none text-sm text-slate-700">Campo obligatorio</label>
                              </div>
                              <div class="flex items-center gap-3 min-h-[2.75rem] px-3 border border-slate-300 rounded-md bg-white">
                                <p-checkbox formControlName="includeInInvoice" [inputId]="'sale-fieldIncludeInInvoice-' + i" [binary]="true" />
                                <label [for]="'sale-fieldIncludeInInvoice-' + i" class="cursor-pointer select-none text-sm text-slate-700">Incluir en la factura</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                    </div>
                  </div>
                </p-tabpanel>

                <p-tabpanel value="suscripciones">
                  <div formGroupName="companySubscriptionConfig">
                    <div class="mt-4 pt-2 max-w-2xl">
                      <div class="mb-4">
                        <h3 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
                          <i class="pi pi-clock"></i>
                          Hora de renovación
                        </h3>
                        <p class="text-sm text-slate-500">
                          Hora UTC aplicada al próximo cobro al crear o renovar una suscripción.
                        </p>
                      </div>

                      <div class="rounded-lg border border-slate-200 bg-slate-50/80 px-4 py-4 max-w-md">
                        <div class="flex flex-col gap-1">
                          <label for="renewalsHourUTC" class="block text-sm font-medium text-slate-900">
                            Hora de renovación (UTC)
                          </label>
                          <p class="text-xs text-slate-500 mb-2">
                            Se suma a la fecha de próximo cobro al crear o renovar una suscripción. Ej: para renovar a las 10:00 en Ciudad de México, configura 16:00 UTC.
                          </p>
                          <input
                            pInputText
                            id="renewalsHourUTC"
                            type="time"
                            formControlName="renewalsHourUTC"
                            step="60"
                            fluid
                            class="max-w-[10rem]"
                            [invalid]="(subscriptionConfigGroup.get('renewalsHourUTC')?.invalid ?? false) && (subscriptionConfigGroup.get('renewalsHourUTC')?.touched ?? false)"
                          />
                          @if (subscriptionConfigGroup.get('renewalsHourUTC')?.hasError('required') && subscriptionConfigGroup.get('renewalsHourUTC')?.touched) {
                            <small class="text-red-600">La hora es requerida</small>
                          } @else if (subscriptionConfigGroup.get('renewalsHourUTC')?.hasError('pattern') && subscriptionConfigGroup.get('renewalsHourUTC')?.touched) {
                            <small class="text-red-600">Formato de hora inválido</small>
                          }
                        </div>
                      </div>
                    </div>

                    <div class="mt-8 border-t border-slate-200 pt-6">
                      <div class="flex items-start justify-between gap-4 mb-4">
                        <div>
                          <h3 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
                            <i class="pi pi-sliders-h"></i>
                            Campos dinámicos
                          </h3>
                          <p class="text-sm text-slate-500">Información adicional en el formulario de suscripciones.</p>
                        </div>
                        <p-button label="Agregar campo" icon="pi pi-plus" size="small" type="button" (onClick)="addDynamicField('subscription')" />
                      </div>

                    <div formArrayName="dynamicFields" class="flex flex-col gap-4">
                      @if (subscriptionDynamicFieldsArray.length === 0) {
                        <div class="rounded-lg border border-dashed border-slate-200 bg-slate-50 px-4 py-8 text-center text-sm text-slate-500">
                          No hay campos dinámicos configurados.
                        </div>
                      }
                      @for (fieldCtrl of subscriptionDynamicFieldsArray.controls; track $index; let i = $index) {
                        <div [formGroupName]="i" class="rounded-lg border border-slate-200 bg-slate-50/60 p-4">
                          <div class="flex items-center justify-between gap-3 mb-4">
                            <span class="text-sm font-medium text-slate-800">Campo {{ i + 1 }}</span>
                            <p-button
                              icon="pi pi-trash"
                              [rounded]="true"
                              [text]="true"
                              severity="danger"
                              type="button"
                              (onClick)="removeDynamicField('subscription', i)"
                              pTooltip="Eliminar campo"
                              tooltipPosition="left"
                            />
                          </div>
                          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div class="flex flex-col gap-1">
                              <p-floatlabel variant="on">
                                <input
                                  pInputText
                                  [id]="'sub-fieldLabel-' + i"
                                  formControlName="label"
                                  [maxlength]="200"
                                  fluid
                                  autocomplete="off"
                                  (blur)="onLabelBlur('subscription', i)"
                                  [invalid]="(fieldCtrl.get('label')?.invalid ?? false) && (fieldCtrl.get('label')?.touched ?? false)"
                                />
                                <label [for]="'sub-fieldLabel-' + i">Etiqueta <span class="text-red-500">*</span></label>
                              </p-floatlabel>
                              <p class="text-xs text-slate-500">Nombre con el que se mostrará en el formulario de suscripciones.</p>
                              @if (fieldCtrl.get('label')?.hasError('required') && fieldCtrl.get('label')?.touched) {
                                <small class="text-red-600">La etiqueta es requerida</small>
                              } @else if (fieldCtrl.get('label')?.hasError('specialChars') && fieldCtrl.get('label')?.touched) {
                                <small class="text-red-600">Solo letras, números y espacios (se permiten acentos)</small>
                              }
                            </div>
                            <div class="flex flex-col gap-1">
                              <p-floatlabel variant="on">
                                <input
                                  pInputText
                                  [id]="'sub-fieldKey-' + i"
                                  formControlName="fieldKey"
                                  [maxlength]="100"
                                  fluid
                                  autocomplete="off"
                                  [invalid]="(fieldCtrl.get('fieldKey')?.invalid ?? false) && (fieldCtrl.get('fieldKey')?.touched ?? false)"
                                />
                                <label [for]="'sub-fieldKey-' + i">Clave <span class="text-red-500">*</span></label>
                              </p-floatlabel>
                              <p class="text-xs text-slate-500">
                                @if (isFieldKeyLocked('subscription', i)) {
                                  La clave no se puede modificar una vez guardada.
                                } @else {
                                  Nombre interno del campo. No se mostrará al usuario.
                                }
                              </p>
                            </div>
                            <div class="flex flex-col gap-1">
                              <p-floatlabel class="w-full" variant="on">
                                <p-select
                                  formControlName="type"
                                  [inputId]="'sub-fieldType-' + i"
                                  [options]="dynamicFieldTypeOptions"
                                  optionLabel="label"
                                  optionValue="value"
                                  class="w-full"
                                  (onChange)="onDynamicFieldTypeChange()"
                                />
                                <label [for]="'sub-fieldType-' + i">Tipo</label>
                              </p-floatlabel>
                            </div>
                            @if (isSelectFieldType('subscription', i)) {
                              <div class="flex flex-col gap-1 md:col-span-2">
                                <p-floatlabel variant="on">
                                  <input
                                    pInputText
                                    [id]="'sub-fieldOptions-' + i"
                                    formControlName="optionsText"
                                    [maxlength]="1000"
                                    fluid
                                    autocomplete="off"
                                  />
                                  <label [for]="'sub-fieldOptions-' + i">Opciones (separadas por coma)</label>
                                </p-floatlabel>
                                <p class="text-xs text-slate-500">Ej: Opción A, Opción B, Opción C</p>
                              </div>
                            }
                            <div class="flex flex-col gap-1 md:col-span-2">
                              <p-floatlabel variant="on">
                                <input
                                  pInputText
                                  [id]="'sub-fieldRegex-' + i"
                                  formControlName="validationRegex"
                                  [maxlength]="500"
                                  fluid
                                  autocomplete="off"
                                />
                                <label [for]="'sub-fieldRegex-' + i">Regex de validación (opcional)</label>
                              </p-floatlabel>
                            </div>
                            <div class="flex flex-wrap items-center gap-4 md:col-span-2">
                              <div class="flex items-center gap-3 min-h-[2.75rem] px-3 border border-slate-300 rounded-md bg-white">
                                <p-checkbox formControlName="required" [inputId]="'sub-fieldRequired-' + i" [binary]="true" />
                                <label [for]="'sub-fieldRequired-' + i" class="cursor-pointer select-none text-sm text-slate-700">Campo obligatorio</label>
                              </div>
                              <div class="flex items-center gap-3 min-h-[2.75rem] px-3 border border-slate-300 rounded-md bg-white">
                                <p-checkbox formControlName="includeInInvoice" [inputId]="'sub-fieldIncludeInInvoice-' + i" [binary]="true" />
                                <label [for]="'sub-fieldIncludeInInvoice-' + i" class="cursor-pointer select-none text-sm text-slate-700">Incluir en la factura</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                    </div>
                  </div>
                </p-tabpanel>

                <p-tabpanel value="notificaciones">
                  <div formGroupName="companyNotificationConfig">
                    <div class="mt-4 mb-4">
                      <h3 class="text-lg font-semibold text-slate-900">Configuración de cuenta de correo</h3>
                      <p class="text-sm text-slate-500">Configuración del correo usado para notificaciones a clientes.</p>
                    </div>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 w-full">
                      <div class="flex flex-col gap-1 w-full md:col-span-2">
                        <p-floatlabel variant="on" class="w-full">
                          <input
                            pInputText
                            id="domain"
                            formControlName="domain"
                            [maxlength]="255"
                            fluid
                            autocomplete="off"
                          />
                          <label for="domain">Dominio de correo</label>
                        </p-floatlabel>
                        <p class="text-xs text-slate-500">Dominio Mailgun para el envío de notificaciones (ej. correos.pento.mx).</p>
                      </div>
                      <div class="flex flex-col gap-1 w-full">
                        <p-floatlabel variant="on" class="w-full">
                          <input
                            pInputText
                            id="sendEmail"
                            formControlName="sendEmail"
                            type="email"
                            [maxlength]="255"
                            fluid
                            autocomplete="off"
                            [invalid]="(notificationConfigGroup.get('sendEmail')?.invalid ?? false) && (notificationConfigGroup.get('sendEmail')?.touched ?? false)"
                          />
                          <label for="sendEmail">Email de envío</label>
                        </p-floatlabel>
                        <p class="text-xs text-slate-500">Dirección desde la que se envían las notificaciones a los clientes.</p>
                        @if (notificationConfigGroup.get('sendEmail')?.hasError('email') && notificationConfigGroup.get('sendEmail')?.touched) {
                          <small class="text-red-600">Ingresa un email válido</small>
                        }
                      </div>
                      <div class="flex flex-col gap-1 w-full">
                        <p-floatlabel variant="on" class="w-full">
                          <input
                            pInputText
                            id="endEmailAlias"
                            formControlName="endEmailAlias"
                            [maxlength]="200"
                            fluid
                            autocomplete="off"
                          />
                          <label for="endEmailAlias">Alias del email de envío</label>
                        </p-floatlabel>
                        <p class="text-xs text-slate-500">Nombre visible del remitente (From name).</p>
                      </div>
                      <div class="flex flex-col gap-1 w-full">
                        <p-floatlabel variant="on" class="w-full">
                          <input
                            pInputText
                            id="replayEmail"
                            formControlName="replayEmail"
                            type="email"
                            [maxlength]="255"
                            fluid
                            autocomplete="off"
                            [invalid]="(notificationConfigGroup.get('replayEmail')?.invalid ?? false) && (notificationConfigGroup.get('replayEmail')?.touched ?? false)"
                          />
                          <label for="replayEmail">Email de respuesta</label>
                        </p-floatlabel>
                        <p class="text-xs text-slate-500">Dirección a la que llegarán las respuestas (Reply-To).</p>
                        @if (notificationConfigGroup.get('replayEmail')?.hasError('email') && notificationConfigGroup.get('replayEmail')?.touched) {
                          <small class="text-red-600">Ingresa un email válido</small>
                        }
                      </div>
                      <div class="flex flex-col gap-1 w-full">
                        <p-floatlabel variant="on" class="w-full">
                          <input
                            pInputText
                            id="replayEmailAlias"
                            formControlName="replayEmailAlias"
                            [maxlength]="200"
                            fluid
                            autocomplete="off"
                          />
                          <label for="replayEmailAlias">Alias del email de respuesta</label>
                        </p-floatlabel>
                        <p class="text-xs text-slate-500">Nombre visible asociado al email de respuesta.</p>
                      </div>
                    </div>
                  </div>

                  <div class="mt-8 border-t border-slate-200 pt-2">
                    <app-company-customer-notification-config />
                  </div>
                </p-tabpanel>

                @if (showMitConfig) {
                  <p-tabpanel value="mit">
                    <app-company-mit-config />
                  </p-tabpanel>
                }
              </p-tabpanels>
            </p-tabs>
          </div>
        </div>

        <ng-template #footer>
          <div class="!mt-4 flex justify-end gap-4 mt-1 !p-4 !-m-5 bg-gray-50 p-2 border-t border-slate-200">
            <p-button label="Cancelar" severity="secondary" (onClick)="cancel()" [loading]="loading()" type="button" />
            <p-button
              [label]="loading() ? 'Guardando...' : 'Guardar configuración'"
              [loading]="loading()"
              [disabled]="configForm.invalid || sectionsInvalid() || loading() || !company()"
              type="submit"
              appDisableUnless="COMPANY_CONFIG_WRITE"
            />
          </div>
        </ng-template>
      </p-card>
    </form>
  }
</div>
